import clsx from "clsx";
import AgentIcon from "@/shared/assets/png/agent-icon.png";
import { VectorWhiteIcon } from "@/shared/assets/svg/icons";
import "./ai-chat-header.scss";

interface AiChatHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const AiChatHeader = ({ isOpen, onToggle }: AiChatHeaderProps) => {
  return (
    <div
      className={clsx("ai-chat-header", isOpen && "ai-chat-header--open")}
      onClick={onToggle}
    >
      <div className="ai-chat-subheader">
        <img
          className="ai-chat-agent-icon"
          src={AgentIcon}
          alt="ИИ-агент"
          width={20}
          height={20}
        />
        <div className="ai-chat-title">Ассистент Билдог</div>
      </div>
      <VectorWhiteIcon
        className={clsx("ai-chat-scroll-icon", isOpen && "ai-chat-scroll-icon--open")}
      />
    </div>
  );
};

